import React, { useContext, useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Typography, notification } from 'antd'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { Gauge } from '@ant-design/plots'

import { Course } from '../Components/Course/types'
import { CourseContext } from '../Components/Course/CourseContext'
import { FlexRow } from '../Components/FlexboxReusables/FlexItems'
import LoadingSpinner from '../Components/LoadingSpinner'
import { CheckCircle } from 'react-feather'

const PublishedCourseOverview = () => {
  const intl = useIntl()
  const navigate = useNavigate()

  const { id } = useParams<{ id: string }>()
  const courseId = id ? parseInt(id) : null // react router hook 'useParams' needs a string, but we need a number

  const { courseContext } = useContext(CourseContext)

  const [ course, setCourse ] = useState<Course | null>(null)
  const [ loadingCourse, setLoadingCourse ] = useState<boolean>(true)

  useEffect(() => {
    const existingCourse = courseContext.courses.find((course: Course) => course.id === courseId)

    if (!existingCourse) {
      notification.error({
        message: intl.formatMessage({ id: 'notification.error' }),
        description: intl.formatMessage({ id: 'notification.error.courseNotFound' }),
        placement: 'bottomRight',
      })

      navigate('/')
      return
    }

    setCourse(existingCourse)
    setLoadingCourse(false)
  }, [ courseContext ])

  const percentage = 60

  const PercentageCompletedGauge = () => {
    const config = {
      percent: percentage / 100,
      range: {
        color: 'l(0) 0:#14ccaa 1:#17375f ',
      },
      startAngle: Math.PI,
      endAngle: 2 * Math.PI,
      indicator: {
        pointer: {
          style: {
            stroke: '',
          },
        },
        pin: {
          style: {
            stroke: '',
          },
        },
      },
      statistic: {
        title: {
          offsetY: -30,
          style: {
            fontSize: '30px',
            color: '#4B535E',
          },
          formatter: () => `${percentage}%`,
        },
        content: {
          style: {
            fontSize: '24px',
            lineHeight: '44px',
            color: '#4B535E',
          },
          formatter: () => 'Beendet', // INTL!!!
        },
      },
    }
    return <Gauge {...config} />
  }

  return (
    <>
      {loadingCourse ? (
        <FlexRow height='100%' width='100%' justifyContent='center' alignItems='center'>
          <LoadingSpinner />
        </FlexRow>
      ) : course && (
        <>
          <FlexRow justifyContent='center' alignItems='center'>
            <Typography.Title level={4}>Zusammenfassung: {course.name}</Typography.Title>
          </FlexRow>
          <FlexRow justifyContent='center' alignItems='center'>
            <CheckCircle size={20} color='green' />
            <Typography.Text>Veröffentlicht</Typography.Text>
          </FlexRow>
          <Container>
            <PercentageCompletedGauge />
          </Container>
        </>
      )}
    </>
  )
}

export default PublishedCourseOverview

const Container = styled.div`
  width: 25em;
  height: 25em;
`